import moment from 'moment';
import { Clock, Plus, CalendarHeart } from 'lucide-react';
import { Button } from '../ui/button';
import { KIND, kindOf, timeLabel, nameOf, subtitleOf } from './calendarUtils';

export const EventRow = ({ ev, extraLabels, onOpen, showDate }) => {
  const k = KIND[kindOf(ev)];
  return (
    <button type="button" onClick={() => onOpen(ev)} data-testid={`cal-event-${ev.id}`}
      className="w-full flex items-stretch gap-3 text-left rounded-xl border border-border bg-card hover:border-primary/50 hover:shadow-sm transition-[border-color,box-shadow] overflow-hidden">
      <span className={`w-1.5 flex-shrink-0 ${k.bar}`} />
      {showDate && (
        <div className="py-2.5 w-12 flex-shrink-0 text-center">
          <p className="text-lg font-bold leading-none">{moment(ev.start).format('D')}</p>
          <p className="text-[10px] uppercase text-muted-foreground mt-1">{moment(ev.start).format('MMM ddd')}</p>
        </div>
      )}
      <div className="py-2.5 pr-3 min-w-0 flex-1">
        <p className="font-semibold text-sm truncate">{nameOf(ev)}</p>
        <p className="text-xs text-muted-foreground truncate">{subtitleOf(ev, extraLabels)}</p>
        {timeLabel(ev) && <p className="text-xs text-muted-foreground flex items-center gap-1 mt-0.5"><Clock className="h-3 w-3" />{timeLabel(ev)}</p>}
      </div>
    </button>
  );
};

export const DayAgenda = ({ day, events, holiday, extraLabels, onOpen, onAdd }) => (
  <div className="rounded-xl border border-border bg-card p-4" data-testid="cal-day-agenda">
    <div className="flex items-start justify-between gap-3 mb-3">
      <div>
        <p className="text-xs uppercase tracking-wider text-muted-foreground">{moment(day).format('dddd')}</p>
        <h3 className="text-xl font-bold">{moment(day).format('D MMMM YYYY')}</h3>
        {holiday && <p className={`text-xs font-medium mt-0.5 ${holiday.type === 'dini' ? 'text-emerald-600' : 'text-red-600'}`}>{holiday.name}</p>}
      </div>
      <Button size="sm" onClick={() => onAdd(day)} data-testid="cal-add-to-day-btn"><Plus className="h-4 w-4 mr-1" /> Ekle</Button>
    </div>
    {events.length === 0 ? (
      <div className="flex flex-col items-center text-center py-6 text-muted-foreground" data-testid="cal-day-empty">
        <CalendarHeart className="h-8 w-8 mb-2 opacity-40" />
        <p className="text-sm font-medium text-emerald-600">Bu gün boş</p>
        <p className="text-xs">Yeni müşteri veya çekim eklemek için "Ekle"ye dokunun.</p>
      </div>
    ) : (
      <div className="space-y-2">
        {events.map(ev => <EventRow key={ev.id} ev={ev} extraLabels={extraLabels} onOpen={onOpen} />)}
      </div>
    )}
  </div>
);

export const UpcomingList = ({ events, extraLabels, onOpen }) => {
  const groups = {};
  events.forEach(ev => {
    const k = moment(ev.start).format('MMMM YYYY');
    (groups[k] = groups[k] || []).push(ev);
  });
  if (!events.length) return <p className="text-sm text-muted-foreground text-center py-10" data-testid="cal-upcoming-empty">Yaklaşan etkinlik yok.</p>;
  return (
    <div className="space-y-5" data-testid="cal-upcoming-list">
      {Object.entries(groups).map(([month, list]) => (
        <div key={month}>
          <p className="text-xs font-bold uppercase tracking-wider text-muted-foreground mb-2">{month} · {list.length} etkinlik</p>
          <div className="space-y-2">
            {list.map(ev => <EventRow key={ev.id} ev={ev} extraLabels={extraLabels} onOpen={onOpen} showDate />)}
          </div>
        </div>
      ))}
    </div>
  );
};
